import { render, staticRenderFns } from "./PTicketstatusButton.vue?vue&type=template&id=4fda1858"
import script from "./PTicketstatusButton.vue?vue&type=script&lang=js"
export * from "./PTicketstatusButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports